import React from 'react';
import Header from '../components/organisms/Header';
import Footer from '../components/organisms/Footer';
import { NavLink } from '../types';
import './PolicyPage.css';

const PolicyPage: React.FC = () => {
  const navLinks: NavLink[] = [
    { text: 'Home', href: '/' },
    { text: 'Catalog', href: '/catalog' },
    { text: 'Contact', href: '/contact' }
  ];

  const handleEmailSubmit = (email: string): void => {
    console.log('Email subscription:', email);
    // Handle email subscription logic here
  };

  const handleFollowShop = (): void => {
    console.log('Follow on shop clicked');
    // Handle follow shop logic here
  };

  return (
    <div className="App">
      <Header navLinks={navLinks} />
      
      <main className="policy-main">
        <div className="policy-container">
          <div className="policy-header">
            <h1>Terms of Service</h1>
            <p className="policy-intro">
              Please read these terms carefully before placing your order with The Frosting Room.
            </p>
          </div>

          <div className="policy-content">
            <section className="policy-section">
              <h2>Order Modifications</h2>
              <p>
                Orders can be modified up to 7 days before the scheduled delivery or collection date. 
                After this period, changes may not be possible to ensure the quality and timeliness of your cake.
              </p>
            </section>

            <section className="policy-section">
              <h2>Refund and Return Policy</h2>
              <p>
                We do not accept returns for cakes due to their perishable nature. Refunds are only available 
                if the order is canceled at least 14 days before the delivery or collection date.
              </p>
            </section>

            <section className="policy-section">
              <h2>Allergen and Ingredient Disclaimer</h2>
              <p>
                Our cakes may contain common allergens such as nuts, dairy, eggs, and gluten. Please inform us 
                of any dietary restrictions or allergies prior to placing your order.
              </p>
            </section>

            <section className="policy-section">
              <h2>Delivery Information</h2>
              <p>
                We offer delivery and collection options. Delivery fee starts at €10 based on your location and we only offer within Dublin. 
                Our delivery times are Tuesday - Sunday, 12pm - 5pm. When placing your order you will select one of the following windows: 12pm - 1pm, 1pm - 3pm, or 3pm - 5pm. Please ensure 
                someone is available to receive the cake at the scheduled time.
              </p>
            </section>

            <section className="policy-section">
              <h2>Collection Information</h2>
              <p>
                Collection is in Dublin24 and the address will be shared once order has been confirmed. 
                Our collection times are Tuesday - Sunday, 12pm - 5pm. When placing your order you will select one of the following windows: 12pm - 1pm, 1pm - 3pm, or 3pm - 5pm. Please be on time 
                to your scheduled pick up time. If you are running late please let me know! 
                <strong> If you are more than 30 minutes late I will require you to pay a late fee of €10 
                before receiving your order!</strong>
              </p>
            </section>

            <section className="policy-section">
              <h2>Satisfaction Guarantee</h2>
              <p>
                We strive for excellence in every cake we make. If there are any issues with your order, 
                please contact us within 24 hours of delivery, and we will do our best to resolve it.
              </p>
            </section>
          </div>
        </div>
      </main>
      
      <Footer 
        onEmailSubmit={handleEmailSubmit}
        onFollowShop={handleFollowShop}
      />
    </div>
  );
};

export default PolicyPage;
